import thumbnail_1 from '../portfolio-projects/BrainStormer/Branding/thumbnail.png'
// import thumbnail_2 from '../portfolio-projects/BrainStormer/Branding/thumbnail-2.png'
// import thumbnail_3 from '../portfolio-projects/BrainStormer/Branding/thumbnail-3.png'
// import thumbnail_4 from '../portfolio-projects/BrainStormer/Branding/thumbnail-4.png'
import login from '../portfolio-projects/BrainStormer/1_Login.png'
import email from '../portfolio-projects/BrainStormer/2_Email.png'
import password from '../portfolio-projects/BrainStormer/3_Password.png'
import mobile from '../portfolio-projects/BrainStormer/4_Mobile Number.png'
import verfication from '../portfolio-projects/BrainStormer/5_Verification.png'
import notifications from '../portfolio-projects/BrainStormer/6_Notifications.png'
import home from '../portfolio-projects/BrainStormer/7_Home.png'
import courses from '../portfolio-projects/BrainStormer/8.1_Courses_Courses.png'
import profile from '../portfolio-projects/BrainStormer/9.1_Profile_Badges.png'
import quiz from '../portfolio-projects/BrainStormer/11.1_Quiz_Text.png'
import quixEnd from '../portfolio-projects/BrainStormer/13.1_Quiz End.png'    

export const brainStromingApp={
    id:1,
    type:'mobile',
    thumbnails:[thumbnail_1],
    screens:[login,email,password,mobile,verfication,notifications,home,courses,profile,quiz,quixEnd],
    title:'Unleash Your Mind with BrainStormer: Exploring the UI Design of a Cutting-Edge Quiz App',
    intro: "In today's fast-paced world, challenging our minds and engaging in thought-provoking activities is essential. Enter BrainStormer, a dynamic quiz app designed to ignite your intellect and provide an immersive learning experience. In this blog post, we will delve into the intricacies of the BrainStormer app's UI design, uncovering its captivating interface, interactive features, and seamless user experience that make it a standout in the world of quiz apps.",
        features: [
          {
            title: "Captivating and Intuitive Interface",
            description: "BrainStormer captivates users with a visually stunning and intuitive interface. The UI employs a modern aesthetic with eye-catching colors, clear typography, and smooth navigation."
          },
          {
            title: "Diverse Quiz Categories and Levels",
            description: "BrainStormer offers a wide range of quiz categories and difficulty levels, covering topics such as general knowledge, science, pop culture, and history, ensuring a personalized experience."
          },
          {
            title: "Interactive Quiz Experience",
            description: "The app provides engaging quiz formats like multiple choice, true or false, and image-based questions, enhanced with smooth transitions and animations for an immersive experience."
          },
          {
            title: "Instant Feedback and Score Tracking",
            description: "Users receive real-time feedback with correct answers, explanations, and score tracking, allowing them to review performance and strive for improvement after each quiz."
          },
          {
            title: "Social Features and Leaderboards",
            description: "BrainStormer integrates social sharing options and leaderboards, enabling users to share their results and compete with top performers for motivation and engagement."
          },
          {
            title: "Personalized Recommendations and Progress Tracking",
            description: "The app suggests quizzes based on user interests and past performance while offering a history tracking system to help users monitor progress and set learning goals."
          },
          {
            title: "Gamification Elements and Rewards",
            description: "Gamification elements like badges, achievements, and virtual rewards encourage users to complete more quizzes, challenge themselves, and earn recognition for their accomplishments."
          }
        ],
        conclusion: "BrainStormer is an engaging quiz app that challenges users to expand their knowledge, compete, and enjoy learning. With captivating UI, interactive features, and personalized recommendations, it elevates the quiz experience. Download BrainStormer and unlock your intellectual potential!"  
}

